// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseRow_root__VKf-c"};